import axios from 'axios'
import { config } from "../Config/config"

const cariDoctorService = {
    getAll: () => {
        const result = axios.get(config.apiUrl + '/doctor')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    getFilter: (filter) => {
        const result = axios.post(config.apiUrl + '/doctorFilter', filter)
            //ketika berhasil 
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            //untuk pesan errornya
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getFilterData: (filter) => {
        const result = axios.post(config.apiUrl + '/doctorFilterData', filter)
            //ketika berhasil 
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            //untuk pesan errornya
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default cariDoctorService